import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ContractorBanner = () => {
  return (
    <section className="py-12 bg-[#0F172A]" data-testid="contractor-banner-section">
      <div className="max-w-4xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <h3
            className="text-xl font-bold text-white mb-1"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            HVAC Contractors: Join the NOLA HVAC Connect Network
          </h3>
          <p className="text-slate-400 text-sm">
            We connect homeowners with trusted local HVAC professionals.
          </p>
        </div>
        <a href="/contractors" className="flex-shrink-0">
          <Button
            variant="outline"
            className="border-white text-white hover:bg-white hover:text-[#0F172A] font-semibold rounded-full px-6"
            data-testid="contractor-banner-cta"
          >
            Learn More
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </a>
      </div>
    </section>
  );
};

export default ContractorBanner;
